import {
  useApiCreate,
  useApiDelete,
  useApiList,
  useApiSingle,
} from '@/composables/api'
import { Subscriber } from '@/model/data-object/Subscriber'
import { TopicNotification } from '@/model/data-object/TopicNotification'
import { PostNotification } from '@/model/data-object/PostNotification'
import { UserNotification } from '@/model/data-object/UserNotification'
import useConfiguration from '@/composables/configuration/configuration'
import { ApiTimeout } from '@/composables/apiTimeout'

function subscribeTopic(topicId: number, apiTimeout?: ApiTimeout) {
  return useApiCreate<TopicNotification>(
    '/api/prv/v1/notification',
    new TopicNotification(topicId),
    {},
    apiTimeout
  )
}

function subscribePost(postId: number, apiTimeout?: ApiTimeout) {
  return useApiCreate<PostNotification>(
    '/api/prv/v1/notification',
    new PostNotification(postId),
    {},
    apiTimeout
  )
}

function subscribeUser(userId: number) {
  return useApiCreate<UserNotification>(
    '/api/prv/v1/notification',
    new UserNotification(userId)
  )
}

function removeSubscription(subscriptionId: number) {
  return useApiDelete<UserNotification>(
    '/api/prv/v1/notification/' + subscriptionId
  )
}

function isUserSubscribed(userId: number) {
  return useApiSingle<UserNotification>(
    '/api/prv/v1/notification/is-subscribed-to/user/' + userId
  )
}

function getPostSubscriptions(offset: number) {
  const { configuration } = useConfiguration()
  const url = '/api/prv/v1/notification/posts/'

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

function getTopicSubscriptions(offset?: number) {
  const { configuration } = useConfiguration()
  const url = '/api/prv/v1/notification/topics'

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

function fetchMySubscribers(offset?: number) {
  const { configuration } = useConfiguration()
  const url = '/api/prv/v1/notification/subscribed-users'

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

function fetchMyFollowers(offset?: number) {
  const { configuration } = useConfiguration()
  const url = '/api/prv/v1/notification/followers'

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

function fetchUserFollowers(userId: number, offset?: number) {
  const { configuration } = useConfiguration()
  const url = 'api/pub/v1/notification/followers/user/' + userId

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

function fetchUserSubscribedUsers(userId: number, offset?: number) {
  const { configuration } = useConfiguration()
  const url = 'api/pub/v1/notification/subscribed-users/user/' + userId

  return useApiList<Array<Subscriber>>(url, {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

export default function useSubscribersApi() {
  return {
    fetchMyFollowers,
    fetchMySubscribers,
    fetchUserFollowers,
    fetchUserSubscribedUsers,
    subscribeTopic,
    subscribePost,
    subscribeUser,
    removeSubscription,
    isUserSubscribed,
    getPostSubscriptions,
    getTopicSubscriptions,
  }
}
